// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  transition: box-shadow 0.2s;
  position: relative;
}

.comment-card:hover {
  box-shadow: 0 2px 8px var(--shadow-color);
}

/* Highlight applied when returning from detail view */
.comment-card.focus-highlight {
  animation: focus-pulse 1.6s ease-in-out;
  box-shadow: 0 6px 18px var(--shadow-color);
}

@keyframes focus-pulse {
  0% { border-color: var(--accent-primary); background-color: rgba(var(--overlay-bg), 0.6); }
}

.comment-card .post-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
}

.comment-card .header-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  max-width:90%;
}

.comment-card .author-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
}

.comment-card .optimistic-status.pending {
  display:none !important;
}

.comment-card .post-author-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
  flex: 1 1;
}

.comment-card .author-avatar {
  width: 60px;
  height: 60px;
  border-radius: 20%;
  object-fit: cover;
}

.comment-card .post-label {
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
}

.comment-card .feed-label {
  background: var(--bg-tertiary);
  color: var(--accent-primary);
  border: 1px solid var(--accent-primary);
}

.comment-card .feed-label:hover {
  background: var(--accent-primary);
  color: var(--bg-tertiary);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-color);
  text-decoration: none;
}

.comment-card .community-label {
  background: var(--bg-tertiary);
  color: var(--accent-primary);
  border: 1px solid var(--accent-primary);
}

.comment-card .community-label:hover {
  background: var(--accent-primary);
  color: var(--bg-tertiary);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-color);
  text-decoration: none;
}

.comment-card .reply-label {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  font-style: italic;
  cursor: default;
}

/* Reblog styles */
.comment-card .reblog-label {
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-style: italic;
  margin: 8px 0;
}

.comment-card .reblog-commentary {
  margin: 8px 0 12px 0;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-primary);
  font-style: italic;
}

.comment-card .reblog-commentary p {
  margin: 0;
  line-height: 1.5;
}

.comment-card .reblog-content {
  background: var(--bg-tertiary);
  padding: 12px;
  border-radius: 8px;
  border-left: 3px solid var(--accent-primary);
  margin-top: 8px;
}

.comment-card .reblog-original-header {
  margin-bottom: 8px;
}

.comment-card .original-author {
  font-weight: 600;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.95rem;
}

.comment-card .original-author:hover {
  text-decoration: underline;
}

.comment-card .reblog-actions {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border-color);
}

.comment-card .view-reblog-link {
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.comment-card .view-reblog-link:hover {
  text-decoration: underline;
}

.comment-card .reblog-markdown-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.comment-card .reblog-markdown-content p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-primary);
}

.comment-card .reblog-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 4px 0;
}

.comment-card .reblog-url-link {
  color: var(--primary-color);
  text-decoration: none;
  word-break: break-all;
  font-size: 13px;
}

.comment-card .reblog-url-link:hover {
  text-decoration: underline;
}

.comment-card .author-info {
  display: flex;
  flex-direction: column;
}

.comment-card .author-name {
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  align-items: center;
}

.comment-card .post-date {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.comment-card .reputation {
  background: var(--reputation-bg);
  color: var(--reputation-text);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.comment-card .post-content-link {
  text-decoration: none;
  color: inherit;
}

.comment-card .post-content-link:hover {
  text-decoration: none;
}

.comment-card .post-body {
  color: var(--text-primary);
  line-height: 1.5;
  margin-bottom: 12px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.comment-card .post-time {
  font-size: 12px;
  color: var(--text-secondary);
  cursor: default;
}

.comment-card .post-via-app {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--text-secondary);
  vertical-align: middle;
}

.comment-card .post-via-app em {
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
}

.comment-card .optimistic-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  margin-bottom: 8px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.comment-card .optimistic-status.failed {
  background: rgba(255, 99, 71, 0.12);
  color: #ff6347;
}

.comment-card .optimistic-status.confirmed {
  background: rgba(46, 160, 67, 0.12);
  color: #2ea043;
}

.comment-card .retry-optimistic-btn {
  background: transparent;
  border: 1px solid currentColor;
  color: inherit;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  cursor: pointer;
}

.comment-card .retry-optimistic-btn:hover {
  opacity: 0.8;
}

.comment-card .post-images {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.comment-card .post-image {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  border: 1px solid var(--border-color);
}

.comment-card .read-more-indicator {
  color: var(--accent-primary);
  font-weight: 500;
  margin-left: 4px;
}

.comment-card .post-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.comment-card .tag {
  color: var(--accent-primary);
  font-size: 0.9rem;
  text-decoration: none;
}

.comment-card .tag:hover {
  text-decoration: underline;
}

.comment-card .post-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid var(--border-color);
  margin-top: 8px;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.comment-card .payout-info {
  font-weight: 600;
  color: var(--success-color);
}

.comment-card .replies-count {
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .comment-card {
    padding: 12px;
    border-radius: 8px;
  }

  .author-avatar {
    width: 35px;
    height: 35px;
  }
}

/* Post stats styling */
.comment-card .post-stats {
  display: flex;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color);
  margin-top: 12px;
}

.comment-card .stat {
  color: var(--text-secondary);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.comment-card .comment-toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
  transition: color 0.2s;
}

.comment-card .comment-toggle-btn:hover {
  color: var(--accent-primary);
}

/* Inline comments section */
.comment-card .inline-comments-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 2px solid var(--border-color);
}

.comment-card .comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.comment-card .comments-header h4 {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary);
}

.comment-card .view-all-link {
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
}

.comment-card .view-all-link:hover {
  text-decoration: underline;
}

.comment-card .no-comments-container {
  text-align: center;
  padding: 16px 0;
}

.comment-card .no-comments {
  color: var(--text-secondary);
  font-style: italic;
  font-size: 0.9rem;
  margin: 8px 0 12px 0;
}

.comment-card .be-first-btn {
  background: var(--accent-primary);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.comment-card .be-first-btn:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.comment-card .inline-comments-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.comment-card .reply-login-prompt {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  margin-top: 12px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: var(--bg-tertiary);
}

.comment-card .reply-login-prompt p {
  margin: 0;
  color: var(--text-secondary);
}

.comment-card .inline-comment {
  padding: 10px;
  background: var(--bg-tertiary);
  border-radius: 8px;
  border-left: 3px solid var(--border-color);
  transition: border-color 0.2s;
}

.comment-card .inline-comment:hover {
  border-left-color: var(--accent-primary);
}

.comment-card .inline-comment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.comment-card .comment-author {
  font-weight: 600;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.9rem;
}

.comment-card .comment-author:hover {
  text-decoration: underline;
}

.comment-card .comment-time {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.comment-card .inline-comment-body {
  color: var(--text-primary);
  line-height: 1.4;
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin-bottom: 8px;
}

.comment-card .toggle-replies-btn-inline {
  background: transparent;
  border: none;
  color: var(--accent-primary);
  cursor: pointer;
  padding: 4px 8px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-top: 4px;
}

.comment-card .toggle-replies-btn-inline:hover {
  text-decoration: underline;
}

.comment-card .inline-comment-replies {
  margin-top: 8px;
}

.comment-card .view-deeper-link {
  display: inline-block;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 6px 12px;
  background: var(--bg-secondary);
  border-radius: 6px;
  margin-top: 8px;
  border: 1px solid var(--border-color);
}

.comment-card .view-deeper-link:hover {
  text-decoration: underline;
  background: var(--bg-tertiary);
}

/* Comments loading state */
.comment-card .comments-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  gap: 12px;
}

.comment-card .comments-loading p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin: 0;
}

.comment-card .loading-dots {
  display: flex;
  gap: 8px;
  align-items: center;
}

.comment-card .loading-dots .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent-primary);
  animation: pulse-dot 1.4s infinite ease-in-out both;
}

.comment-card .loading-dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.comment-card .loading-dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes pulse-dot {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CommentCard/CommentCard.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sDAAsD;AACtD;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,KAAK,mCAAmC,EAAE,8CAA8C,EAAE;AAC5F;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".comment-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n  transition: box-shadow 0.2s;\n  position: relative;\n}\n\n.comment-card:hover {\n  box-shadow: 0 2px 8px var(--shadow-color);\n}\n\n/* Highlight applied when returning from detail view */\n.comment-card.focus-highlight {\n  animation: focus-pulse 1.6s ease-in-out;\n  box-shadow: 0 6px 18px var(--shadow-color);\n}\n\n@keyframes focus-pulse {\n  0% { border-color: var(--accent-primary); background-color: rgba(var(--overlay-bg), 0.6); }\n}\n\n.comment-card .post-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.comment-card .header-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  max-width:90%;\n}\n\n.comment-card .author-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.comment-card .optimistic-status.pending {\n  display:none !important;\n}\n\n.comment-card .post-author-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  color: inherit;\n  flex: 1;\n}\n\n.comment-card .author-avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 20%;\n  object-fit: cover;\n}\n\n.comment-card .post-label {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 12px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n\n.comment-card .feed-label {\n  background: var(--bg-tertiary);\n  color: var(--accent-primary);\n  border: 1px solid var(--accent-primary);\n}\n\n.comment-card .feed-label:hover {\n  background: var(--accent-primary);\n  color: var(--bg-tertiary);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px var(--shadow-color);\n  text-decoration: none;\n}\n\n.comment-card .community-label {\n  background: var(--bg-tertiary);\n  color: var(--accent-primary);\n  border: 1px solid var(--accent-primary);\n}\n\n.comment-card .community-label:hover {\n  background: var(--accent-primary);\n  color: var(--bg-tertiary);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px var(--shadow-color);\n  text-decoration: none;\n}\n\n.comment-card .reply-label {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n  font-style: italic;\n  cursor: default;\n}\n\n/* Reblog styles */\n.comment-card .reblog-label {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  font-style: italic;\n  margin: 8px 0;\n}\n\n.comment-card .reblog-commentary {\n  margin: 8px 0 12px 0;\n  padding: 8px 0;\n  font-size: 14px;\n  color: var(--text-primary);\n  font-style: italic;\n}\n\n.comment-card .reblog-commentary p {\n  margin: 0;\n  line-height: 1.5;\n}\n\n.comment-card .reblog-content {\n  background: var(--bg-tertiary);\n  padding: 12px;\n  border-radius: 8px;\n  border-left: 3px solid var(--accent-primary);\n  margin-top: 8px;\n}\n\n.comment-card .reblog-original-header {\n  margin-bottom: 8px;\n}\n\n.comment-card .original-author {\n  font-weight: 600;\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: 0.95rem;\n}\n\n.comment-card .original-author:hover {\n  text-decoration: underline;\n}\n\n.comment-card .reblog-actions {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-color);\n}\n\n.comment-card .view-reblog-link {\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.comment-card .view-reblog-link:hover {\n  text-decoration: underline;\n}\n\n.comment-card .reblog-markdown-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.comment-card .reblog-markdown-content p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--text-primary);\n}\n\n.comment-card .reblog-image {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin: 4px 0;\n}\n\n.comment-card .reblog-url-link {\n  color: var(--primary-color);\n  text-decoration: none;\n  word-break: break-all;\n  font-size: 13px;\n}\n\n.comment-card .reblog-url-link:hover {\n  text-decoration: underline;\n}\n\n.comment-card .author-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.comment-card .author-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n}\n\n.comment-card .post-date {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.comment-card .reputation {\n  background: var(--reputation-bg);\n  color: var(--reputation-text);\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.comment-card .post-content-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.comment-card .post-content-link:hover {\n  text-decoration: none;\n}\n\n.comment-card .post-body {\n  color: var(--text-primary);\n  line-height: 1.5;\n  margin-bottom: 12px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.comment-card .post-time {\n  font-size: 12px;\n  color: var(--text-secondary);\n  cursor: default;\n}\n\n.comment-card .post-via-app {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 6px;\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  color: var(--text-secondary);\n  vertical-align: middle;\n}\n\n.comment-card .post-via-app em {\n  font-style: italic;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.comment-card .optimistic-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  margin-bottom: 8px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n.comment-card .optimistic-status.failed {\n  background: rgba(255, 99, 71, 0.12);\n  color: #ff6347;\n}\n\n.comment-card .optimistic-status.confirmed {\n  background: rgba(46, 160, 67, 0.12);\n  color: #2ea043;\n}\n\n.comment-card .retry-optimistic-btn {\n  background: transparent;\n  border: 1px solid currentColor;\n  color: inherit;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.comment-card .retry-optimistic-btn:hover {\n  opacity: 0.8;\n}\n\n.comment-card .post-images {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.comment-card .post-image {\n  max-width: 100%;\n  height: auto;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n}\n\n.comment-card .read-more-indicator {\n  color: var(--accent-primary);\n  font-weight: 500;\n  margin-left: 4px;\n}\n\n.comment-card .post-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.comment-card .tag {\n  color: var(--accent-primary);\n  font-size: 0.9rem;\n  text-decoration: none;\n}\n\n.comment-card .tag:hover {\n  text-decoration: underline;\n}\n\n.comment-card .post-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-color);\n  margin-top: 8px;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.comment-card .payout-info {\n  font-weight: 600;\n  color: var(--success-color);\n}\n\n.comment-card .replies-count {\n  color: var(--text-secondary);\n}\n\n@media (max-width: 768px) {\n  .comment-card {\n    padding: 12px;\n    border-radius: 8px;\n  }\n\n  .author-avatar {\n    width: 35px;\n    height: 35px;\n  }\n}\n\n/* Post stats styling */\n.comment-card .post-stats {\n  display: flex;\n  gap: 16px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-color);\n  margin-top: 12px;\n}\n\n.comment-card .stat {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.comment-card .comment-toggle-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  transition: color 0.2s;\n}\n\n.comment-card .comment-toggle-btn:hover {\n  color: var(--accent-primary);\n}\n\n/* Inline comments section */\n.comment-card .inline-comments-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 2px solid var(--border-color);\n}\n\n.comment-card .comments-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.comment-card .comments-header h4 {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n.comment-card .view-all-link {\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.comment-card .view-all-link:hover {\n  text-decoration: underline;\n}\n\n.comment-card .no-comments-container {\n  text-align: center;\n  padding: 16px 0;\n}\n\n.comment-card .no-comments {\n  color: var(--text-secondary);\n  font-style: italic;\n  font-size: 0.9rem;\n  margin: 8px 0 12px 0;\n}\n\n.comment-card .be-first-btn {\n  background: var(--accent-primary);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.comment-card .be-first-btn:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n.comment-card .inline-comments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.comment-card .reply-login-prompt {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  margin-top: 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  background: var(--bg-tertiary);\n}\n\n.comment-card .reply-login-prompt p {\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.comment-card .inline-comment {\n  padding: 10px;\n  background: var(--bg-tertiary);\n  border-radius: 8px;\n  border-left: 3px solid var(--border-color);\n  transition: border-color 0.2s;\n}\n\n.comment-card .inline-comment:hover {\n  border-left-color: var(--accent-primary);\n}\n\n.comment-card .inline-comment-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.comment-card .comment-author {\n  font-weight: 600;\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: 0.9rem;\n}\n\n.comment-card .comment-author:hover {\n  text-decoration: underline;\n}\n\n.comment-card .comment-time {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.comment-card .inline-comment-body {\n  color: var(--text-primary);\n  line-height: 1.4;\n  font-size: 0.9rem;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  margin-bottom: 8px;\n}\n\n.comment-card .toggle-replies-btn-inline {\n  background: transparent;\n  border: none;\n  color: var(--accent-primary);\n  cursor: pointer;\n  padding: 4px 8px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.comment-card .toggle-replies-btn-inline:hover {\n  text-decoration: underline;\n}\n\n.comment-card .inline-comment-replies {\n  margin-top: 8px;\n}\n\n.comment-card .view-deeper-link {\n  display: inline-block;\n  color: var(--accent-primary);\n  text-decoration: none;\n  font-size: 0.85rem;\n  font-weight: 500;\n  padding: 6px 12px;\n  background: var(--bg-secondary);\n  border-radius: 6px;\n  margin-top: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.comment-card .view-deeper-link:hover {\n  text-decoration: underline;\n  background: var(--bg-tertiary);\n}\n\n/* Comments loading state */\n.comment-card .comments-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px 20px;\n  gap: 12px;\n}\n\n.comment-card .comments-loading p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.comment-card .loading-dots {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.comment-card .loading-dots .dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n  animation: pulse-dot 1.4s infinite ease-in-out both;\n}\n\n.comment-card .loading-dots .dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.comment-card .loading-dots .dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes pulse-dot {\n  0%, 80%, 100% {\n    transform: scale(0.6);\n    opacity: 0.3;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
